import { getOidcUser } from "app/config/oidc";

const getHeaders = () => {
    const currentUserInfo = getOidcUser();
    return {
        'Content-Type': 'application/json',
        Authorization: `${currentUserInfo?.token_type} ${currentUserInfo?.access_token}`
    }
}

const getHeadersAuth = () => {
    const currentUserInfo = getOidcUser();
    return {
        'Content-Type': 'application/json',
        Authorization: `${currentUserInfo?.token_type} ${currentUserInfo?.access_token}`
    }
}

const getHeadersAuthFormData = () => {
    const currentUserInfo = getOidcUser();
    return {
        'Content-Type': 'multipart/form-data',
        Authorization: `${currentUserInfo?.token_type} ${currentUserInfo?.access_token}`
    }
}

export const HeadersUtil = {
    getHeaders: getHeaders,
    getHeadersAuth: getHeadersAuth,
    getHeadersAuthFormData: getHeadersAuthFormData,
}